import { serviceConfigSchema } from './SharedServiceConfig.js';

// ============================================================================
// Core Schema
// ============================================================================
const processingFeesServiceConfigSchema = serviceConfigSchema;
// ============================================================================
// DTO Schema
// ============================================================================
const processingFeesServiceConfigDtoSchema = serviceConfigSchema;

export { processingFeesServiceConfigDtoSchema, processingFeesServiceConfigSchema };
//# sourceMappingURL=ProcessingFeesServiceConfig.js.map
